/**
 * Receipts module configuration
 * ──────────────────────────────
 * Change PAYMENT_LABEL to rename the "Receipt" feature everywhere in this module.
 */
import { ENTITIES } from '../../constants/labels';
import { DOCUMENT_STATUS } from '../../constants/statusMaps';

// ── Change this to rename "Receipt" everywhere in this module ─────────────
export const PAYMENT_LABEL = ENTITIES.receipt;

export { DOCUMENT_STATUS as STATUS_CONFIG };

export const RECEIPT_TYPE_LABEL = {
  standard:  'Standard Donation',
  gold:      'Gold',
  anonymous: 'Shah A/C (Walk-in)',
  item:      'Item',
  bhandar:   'Bhandar',
};
